import {useWebsiteMenuInformation} from '@data/queries/website/websiteMenuInformation.main'
import Product from '@page-components/Order/Products/ProductsContent/Category/Product'
import useCardsV2 from '@page-components/Order/Products/ProductsContent/Category/Product/useCardsV2'

import productsCardClassName from '../../productsCardClassName'

import getSortedProducts from './getSortedProducts'
import useCategoryCPG from './useCategoryCPG.main'

import styles from './styles.module.css'

export interface CategoryCPGProps {
  productsLayout: string
  layout: string
  categoryId: string
  menuId: string
  hidePrice: boolean
  sorting: any
  storeId: string
  deliverAt: Date
}

export default function CategoryCPG(props: CategoryCPGProps) {
  const {productsLayout, layout, categoryId, menuId, hidePrice, sorting, storeId, deliverAt} = props
  const cardsV2 = useCardsV2()
  const {category, loading} = useCategoryCPG({
    categoryId: categoryId,
    storeId,
    deliverAt,
    menuId
  })
  const {design} = useWebsiteMenuInformation()

  const categoryProducts = category?.paginatedProducts?.items

  if (!loading && !categoryProducts?.length) return null

  const productList = getSortedProducts(categoryProducts, sorting)
  const className = productsCardClassName(productsLayout, layout)

  if (cardsV2) {
    return (
      <>
        {categoryProducts?.length > 0 && (
          <div className={styles.container} id={`t111_${categoryId}`}>
            <div className={styles.name}>{category.name}</div>
            <div className="flex flex-row flex-wrap gap-4 justify-center md:justify-start">
              {productList.map(product => {
                return (
                  <Product
                    key={product._id}
                    productCardDesign={design?.design?.productCardDesign}
                    productsLayout={productsLayout}
                    hidePrice={hidePrice}
                    product={product}
                    menuId={menuId}
                  />
                )
              })}
            </div>
          </div>
        )}
      </>
    )
  }

  return (
    <>
      {/* The id of the div bellow is intended as a unique match to Tiramisu's
    layout. Please do not change it. */}
      {categoryProducts?.length > 0 && (
        <div className={styles.container} id={`t111_${categoryId}`}>
          <div className={styles.name}>{category.name}</div>
          <div className={styles.products}>
            <div className="row">
              {productList.map(product => {
                return (
                  <div key={product._id} className={className}>
                    <Product
                      productCardDesign={design?.design?.productCardDesign}
                      productsLayout={productsLayout}
                      hidePrice={hidePrice}
                      product={product}
                      menuId={menuId}
                    />
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      )}
    </>
  )
}
